import { substringBeforekje8w2lxhyb6 as substringBefore } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function serialNameFQN(_this__u8e3s4) {
  return substringBefore(_this__u8e3s4.get_serialName_u2rqhk_k$(), '/');
}
//region block: exports
export {
  serialNameFQN as serialNameFQN3cassnowfodm5,
};
//endregion

//# sourceMappingURL=SerialDescriptor.ext.mjs.map
